<template>
    <div class="box">
      <div class="nature">
        <div class="item" :class="i === index ? 'active':''" v-for="(item,i) in list" :key="i" @click="index === i ? index = null : index = i">
          <div v-if="i !== 5"> {{ item.content }}</div>
          <input type="text" v-model="list[5].content" placeholder="请输入自定义比赛性质" v-else>
        </div>
      </div>
      <div class="footer">
        <div @click="goBack">选定比赛性质</div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  data() {
    return {
      list: [
        { content: '冠/亚军赛', isChampionGame: 1 },
        { content: '3-4名排位赛', isChampionGame : 2},
        { content: '5-6名排位赛', isChampionGame : 3},
        { content: '7-8名排位赛', isChampionGame : 4},
        { content: '交叉排位赛', isChampionGame: -1 },
        { content: '', isChampionGame: -2 },
      ],
      index: null,
      game:{}
    };
  },
  mounted() {
    this.game = this.$store.state.game
    if (this.game.isChampionGame) {
      this.index = this.list.findIndex(item => item.isChampionGame === this.game.isChampionGame)
      if (this.game.isChampionGame === -2) {
        this.list[5].content = this.$store.state.game.content
      }
    }
  },
  methods: {
    goBack() {
      if (this.index === 4 && !this.list[4]) {
        Toast('请输入自定义比赛性质')
        return
      }
      const isChampionGame = this.list[this.index]
      const game = {
        ...this.game,
        ...isChampionGame
      }
      this.$store.dispatch('changeDispatch', game);
      this.$router.back()
    }
  },
};
</script>

<style scoped lang="scss">
.box{
  border-top: 12px solid #F6F6F8;
  .nature{
    padding: 16px;
    .item{
      width: 343px;
      height: 54px;
      background: #F9FAFC;
      border-radius: 8px;
      font-weight: 500;
      text-align: center;
      line-height: 54px;
      margin-bottom: 12px;
      font-size: 14px;
      input{
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        border: none;
        background-color: rgba(0, 0, 0, 0);
        text-align: center;
      }
    }
    .active{
      border: 1px solid #1565FC;
      color: #1565FC;
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: 100%;
    padding: 16px 12px;
    div{
      height: 50px;
      background: #1565FC;
      border-radius: 25px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 50px;
      width: 351px;
    }
  }
}
</style>
